<template>
  <div>
    <div :is="form" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import collections from '@/mixins/collections'

export default {
  name: 'New',
  mixins: [collections],
  data () {
    return {
      name: this.$route.params.collection,
      form: null
    }
  },
  created () {
    this.form = this.collections[this.name].form
    this.setSelectedLocation(null)
  },
  methods: {
    ...mapMutations([
      'setSelectedLocation'
    ])
  }
}
</script>
